import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      amountRules: [
        v => Rules.isRequired(v),
        v => Rules.isNumber(v)
      ],
      notesRules: [
        v => Rules.isRequired(v),
        v => Rules.maxLength(v, 200),
        v => Rules.minLength(v, 3)
      ],

    }
  }
}

